import { render } from "./CanalConfidencial.vue?vue&type=template&id=0b16e770&scoped=true"
import script from "./CanalConfidencial.vue?vue&type=script&lang=js"
export * from "./CanalConfidencial.vue?vue&type=script&lang=js"

import "./CanalConfidencial.vue?vue&type=style&index=0&id=0b16e770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16e770"]])

export default __exports__